import axios from 'axios'
import qs from 'qs'
import { clone, objectToArrayConverter } from '@/util/libUtil.js'
import defaultNewTenantForm from "@/util/rrhh/defaultNewTenantForm.js"


const state = {
    isOpenEditTenantDialog: false,
    tenants: [],
    isLoadingTenants: false,
    newTenant: {
        isOpen: false,
        formType: 'Create',
        form: clone(defaultNewTenantForm)
    },
    paths: {
        tenantsPath: '/api/distribuidores/distribuidor/'
    }
}

const mutations = {
    isLoadingTenants(state, isLoading) {
        state.isLoadingTenants = isLoading
    },
    openNewTenantDialog(state, val) {
        state.newTenant.isOpen = val
    },
    isOpenEditTenantDialog: (state, val) => {
        state.isOpenEditTenantDialog = val
    },
    tenants: (state, val) => {
        state.tenants = val
    },
    defaultNewTenantForm(state) {
        state.newTenant.form = clone(defaultNewTenantForm)
    },
    newTenant: (state, val) => {
        state.newTenant.form = val
    },
    isOpenNuevaCuentaDialogo: (state, val) => {
        state.newTenant.isOpen = val
    },
    tenantFormType: (state, val) => {
        state.newTenant.formType = val
    }
}

const actions = {
    async fetchTenants({ state, commit, getters }) {
        try {
            const res = await axios.get(getters.getEndpointFromPath(state.paths.tenantsPath))
            commit('tenants', res.data)
        } catch (error) {
            console.log(error)
        }
    },
    async deleteTenant({ state, getters, dispatch, commit }, id) {
        try {
            commit('isLoadingTenants', true)
            await axios.delete(`${getters.getEndpointFromPath(state.paths.tenantsPath)}${id}/`)
            dispatch('fetchTenants')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Tenant Borrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Borrar el Tenant',
            }, { root: true })
        }

        commit('isLoadingTenants', false)
    },
    async editTenant({ getters, state, dispatch, commit }) {
        // try {
            let formData = new FormData()
            for (let key in state.newTenant.form) {
                if(key === 'signature') {
                    formData.append(key, state.newTenant.form[key]['0'])
                } else if(typeof state.newTenant.form[key] === 'object' && state.newTenant.form[key]) {
                    let array = objectToArrayConverter(state.newTenant.form[key])
                    array.forEach((element, index) => {
                        formData.append(`${key}[${index}]`, element)
                    })
                } else {
                    formData.append(key, state.newTenant.form[key])
                }
            }
            
            await axios.put(`${getters.getEndpointFromPath(state.paths.tenantsPath)}${state.newTenant.form.id}/`, formData)
            dispatch('fetchTenants')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Tenant Editado!",
            }, { root: true })
        // } catch {
        //     dispatch('util/showStatusSnackBar', {
        //         statusType: 'error',
        //         message: 'Error al editar Tenant',
        //     }, { root: true })
        // }
    },
    async createTenant({ getters, state, dispatch, commit }) {
        // try {
            let formData = new FormData()
            for (let key in state.newTenant.form) {
                if(key === 'signature') {
                    if(state.newTenant.form[key]){
                        formData.append(key, state.newTenant.form[key]['0'])
                    }
                } else if(typeof state.newTenant.form[key] === 'object' && state.newTenant.form[key]) {
                    let array = objectToArrayConverter(state.newTenant.form[key])
                    array.forEach((element, index) => {
                        formData.append(`${key}[${index}]`, element)
                    })
                } else {
                    formData.append(key, state.newTenant.form[key])
                }
            }

            await axios.post(getters.getEndpointFromPath(state.paths.tenantsPath), formData)
            dispatch('fetchTenants')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Tenant Creado!",
            }, { root: true })
        // } catch {
        //     dispatch('util/showStatusSnackBar', {
        //         statusType: 'error',
        //         message: 'Error al crear Tenant',
        //     }, { root: true })
        // }
    },
    async deleteTenantFile({ getters, state, dispatch, commit }, {field, id}) {
        try {
            let params = {
                field: field
            }
            await axios.delete(`${getters.getEndpointFromPath(state.paths.tenantsPath)}${id}`, {
                params: params
            })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Firma del distribuidor borrada!",
            }, { root: true })
        } catch (error) {
            console.log(error)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Actualizar la Imagen de Firma',
            }, { root: true })
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}


